// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var DocumentAnswers = function (x) {
    return x;
};
var tsBridgeDocumentAnswers = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("DocumentAnswers")("__brandDocumentAnswers"));
    }
};
var writeDocumentAnswers = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showDocumentAnswers = Data_Show.showString;
var readDocumentAnswers = Simple_JSON.readString;
var ordDocumentAnswers = Data_Ord.ordString;
var newtypeDocumentAnswers = {
    Coercible0: function () {
        return undefined;
    }
};
var makeDocumentAnswers = DocumentAnswers;
var eqDocumentAnswers = Data_Eq.eqString;
export {
    DocumentAnswers,
    makeDocumentAnswers,
    unwrap,
    newtypeDocumentAnswers,
    eqDocumentAnswers,
    ordDocumentAnswers,
    showDocumentAnswers,
    readDocumentAnswers,
    writeDocumentAnswers,
    tsBridgeDocumentAnswers
};
//# sourceMappingURL=index.js.map
